const firmDay = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Berlin' });
/**
 * The calendar day of an instant in the firms' time (Europe/Berlin), as `YYYY-MM-DD` - the same
 * in the API and in the browser, whatever the person's own time zone.
 */
export const firmDayOf = (instant) => firmDay.format(instant);
const HOUR_MS = 60 * 60 * 1000;
/**
 * The first instant of a calendar day in the firms' time: midnight in Berlin is 23:00 or 22:00
 * UTC of the day before, by the season - the earliest of them that already is that day.
 */
export function startOfFirmDay(day) {
    const utcMidnight = Date.parse(`${day}T00:00:00Z`);
    for (const hours of [2, 1]) {
        const candidate = new Date(utcMidnight - hours * HOUR_MS);
        if (firmDayOf(candidate) === day)
            return candidate;
    }
    throw new Error(`${day} is not a calendar day`);
}
/** The calendar day after `day` (`YYYY-MM-DD`). */
export const dayAfter = (day) => new Date(Date.parse(`${day}T12:00:00Z`) + 24 * HOUR_MS).toISOString().slice(0, 10);
//# sourceMappingURL=firm-day.js.map